export const selectSurveys = (state) => state.surveys.all || [];
export const selectCurrentSurvey = (state) => state.surveys?.current || null;
export const selectIsLoading = (state) => state.surveys.isLoading;
export const selectLastSurvey = (state) => state.surveys.last || null;
export const selectSurveysCount = (state) => state.surveys.count || 0;
